class BecomeAdvertiserService {
  constructor () {
    if (BecomeAdvertiserService.instance) {
      return BecomeAdvertiserService.instance
    }

    BecomeAdvertiserService.instance = this

    return this
  }

  sendForm (engine, name, email, contact, service, comments) {
    return engine.post('/become-advertiser', { name, email, contact, service, comments })
  }
}

export default new BecomeAdvertiserService()
